function promptImage() {
  return prompt("image/*")
}
function prompt(accept) {
  return new Promise((resolve) => {
    // Create a file input element dynamically
    const input = document.createElement("input")
    input.type = "file"
    if (accept) input.accept = accept

    // Listen for the change event when a file is selected
    input.addEventListener("change", () => {
      const file = input.files && input.files[0]
      input.remove()
      resolve(file || null) // Return the file or null if no file selected
    })

    // Listen for the input losing focus to handle user cancellation
    input.addEventListener("blur", () => {
      input.remove()
      resolve(null)
    })

    // Trigger the file input dialog
    input.click()
  })
}

export { promptImage }
